<template>
  <v-card class="rounded-xl ma-2 pa-8">
    <v-data-table
      :headers="headersAvailableOptions"
      :items="updatedAvailableOptions"
      :items-per-page="-1"
      dense
      disable-pagination
      hide-default-footer
    >
      <template v-slot:top>
        <div class="d-flex flex-row flex-wrap">
          <v-card-title>
            Available Options
          </v-card-title>

          <v-spacer />

          <v-btn
            color="ppc_pink"
            dark
            x-small
            absolute
            right
            fab
            @click="$emit('add-option')"
          >
            <v-icon>
              $vuetify.icons.icon_mdi_plus
            </v-icon>
          </v-btn>
        </div>

        <!-- ADD / EDIT OPTION -->
        <v-dialog
          :value="dialogOption"
          max-width="500px"
          persistent
          @input="$emit('update-dialog-option', $event)"
        >
          <v-form ref="dialogForm">
            <v-card>
              <v-card-title class="ppc_darkgreen darken-1">
                <span class="headline white--text">
                  {{ formTitleOptions }}
                </span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model.trim="editedItemOption.option_name"
                      label="Name (required)"
                      counter="45"
                      :rules="inputRulesName"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model.trim="editedItemOption.option_question"
                      label="Question (required)"
                      counter="45"
                      :rules="inputRules100maxReq"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedItemOption.price"
                      label="Price"
                      :rules="inputRulesReq"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedItemOption.varPrice"
                      label="Variable price"
                      :rules="inputRulesReq"
                    />
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer />

                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="$emit('close-option')"
                >
                  Cancel
                </v-btn>

                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="saveOption"
                >
                  Done
                </v-btn>
                
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <!-- DELETE OPTION -->
        <v-dialog
          :value="dialogDeleteOption"
          max-width="500px"
          @input="$emit('update-dialog-delete', $event)"
        >
          <v-card>
            <v-card-title>
              Are you sure you want to delete the option:
              {{ editedItemOption.option_name }}?
            </v-card-title>

            <v-card-actions>
              <v-spacer />

              <v-btn
                color="ppc_darkgreen darken-1"
                text
                @click="$emit('close-delete-option')"
              >
                Cancel
              </v-btn>

              <v-btn
                color="ppc_darkgreen darken-1"
                text
                @click="$emit('delete-option-confirm')"
              >
                Yes
              </v-btn>

              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="$emit('edit-option', item)"
        >
          $vuetify.icons.icon_mdi_pencil
        </v-icon>

        <v-icon
          small
          @click="$emit('delete-option', item)"
        >
          $vuetify.icons.icon_mdi_delete
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import inputRules from '@/mixins/inputRules'

export default {
  name: 'ServiceOptions',

  watch: {
    dialogOption(value) {
      if (value) {
        this.$nextTick(() => {
          this.$refs.dialogForm?.resetValidation()
        })
      }
    }
  },

  mixins: [
    inputRules,
  ],

  props: {
    headersAvailableOptions: {
      type: Array,
      default: () => [],
    },

    updatedAvailableOptions: {
      type: Array,
      default: () => [],
    },

    dialogOption: {
      type: Boolean,
      default: false,
    },

    dialogDeleteOption: {
      type: Boolean,
      default: false,
    },

    editedItemOption: {
      type: Object,
      default: () => ({}),
    },

    formTitleOptions: {
      type: String,
      default: '',
    },
  },

  methods: {
    saveOption() {
      if (this.$refs.dialogForm.validate()) {
        this.$emit('save-option')
      }
    }
  },
}
</script>